var _rect, _path, _path2, _ellipse, _ellipse2, _g, _g2, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMedicalEquipmentBg(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 335,
    height: 74,
    viewBox: "0 0 335 74",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_19491_32756)"
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 335,
    height: 76,
    fill: "url(#paint0_linear_19491_32756)"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_19491_32756",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 335,
    height: 74
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 0H324C330.075 0 335 4.92487 335 11V63C335 69.0751 330.075 74 324 74H11C4.92487 74 0 69.0751 0 63V0Z",
    fill: "#E9F7EF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M0.5 0.5H324C329.799 0.5 334.5 5.20101 334.5 11V63C334.5 68.799 329.799 73.5 324 73.5H11C5.20102 73.5 0.5 68.799 0.5 63V0.5Z",
    stroke: "url(#paint1_linear_19491_32756)",
    strokeOpacity: 0.2
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_19491_32756)"
  }, _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 33.3906,
    cy: 122.197,
    rx: 106.5,
    ry: 103.697,
    fill: "#008633",
    fillOpacity: 0.05
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask1_19491_32756",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: -74,
    y: 18,
    width: 214,
    height: 208
  }, _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 33.3906,
    cy: 122.197,
    rx: 106.5,
    ry: 103.697,
    fill: "#008633",
    fillOpacity: 0.7
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_19491_32756)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M139.791 122.197C139.791 179.41 92.1562 225.795 33.3906 225.795C-25.375 225.795 -73.0094 179.41 -73.0094 122.197C-73.0094 64.9846 -25.375 18.6 33.3906 18.6C92.1562 18.6 139.791 64.9846 139.791 122.197Z",
    stroke: "url(#paint2_linear_19491_32756)",
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M131.355 122.197C131.355 179.41 83.7207 225.795 24.9551 225.795C-33.8106 225.795 -81.4449 179.41 -81.4449 122.197C-81.4449 64.9846 -33.8106 18.6 24.9551 18.6C83.7207 18.6 131.355 64.9846 131.355 122.197Z",
    stroke: "url(#paint3_linear_19491_32756)",
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M122.92 122.197C122.92 179.41 75.2852 225.795 16.5195 225.795C-42.2461 225.795 -89.8805 179.41 -89.8805 122.197C-89.8805 64.9846 -42.2461 18.6 16.5195 18.6C75.2852 18.6 122.92 64.9846 122.92 122.197Z",
    stroke: "url(#paint4_linear_19491_32756)",
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M114.484 122.197C114.484 179.41 66.8496 225.795 8.08398 225.795C-50.6816 225.795 -98.316 179.41 -98.316 122.197C-98.316 64.9846 -50.6816 18.6 8.08398 18.6C66.8496 18.6 114.484 64.9846 114.484 122.197Z",
    stroke: "url(#paint5_linear_19491_32756)",
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106.048 122.197C106.048 179.41 58.4141 225.795 -0.351562 225.795C-59.1172 225.795 -106.752 179.41 -106.752 122.197C-106.752 64.9846 -59.1172 18.6 -0.351562 18.6C58.4141 18.6 106.048 64.9846 106.048 122.197Z",
    stroke: "url(#paint6_linear_19491_32756)",
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M97.6129 122.197C97.6129 179.41 49.9785 225.795 -8.78711 225.795C-67.5527 225.795 -115.187 179.41 -115.187 122.197C-115.187 64.9846 -67.5527 18.6 -8.78711 18.6C49.9785 18.6 97.6129 64.9846 97.6129 122.197Z",
    stroke: "url(#paint7_linear_19491_32756)",
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89.1773 122.197C89.1773 179.41 41.543 225.795 -17.2227 225.795C-75.9883 225.795 -123.623 179.41 -123.623 122.197C-123.623 64.9846 -75.9883 18.6 -17.2227 18.6C41.543 18.6 89.1773 64.9846 89.1773 122.197Z",
    stroke: "url(#paint8_linear_19491_32756)",
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80.7418 122.197C80.7418 179.41 33.1074 225.795 -25.6582 225.795C-84.4238 225.795 -132.058 179.41 -132.058 122.197C-132.058 64.9846 -84.4238 18.6 -25.6582 18.6C33.1074 18.6 80.7418 64.9846 80.7418 122.197Z",
    stroke: "url(#paint9_linear_19491_32756)",
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72.3053 122.197C72.3053 179.41 24.6709 225.795 -34.0947 225.795C-92.8604 225.795 -140.495 179.41 -140.495 122.197C-140.495 64.9846 -92.8604 18.6 -34.0947 18.6C24.6709 18.6 72.3053 64.9846 72.3053 122.197Z",
    stroke: "url(#paint10_linear_19491_32756)",
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.8697 122.197C63.8697 179.41 16.2354 225.795 -42.5303 225.795C-101.296 225.795 -148.93 179.41 -148.93 122.197C-148.93 64.9846 -101.296 18.6 -42.5303 18.6C16.2354 18.6 63.8697 64.9846 63.8697 122.197Z",
    stroke: "url(#paint11_linear_19491_32756)",
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.4342 122.197C55.4342 179.41 7.7998 225.795 -50.9658 225.795C-109.731 225.795 -157.366 179.41 -157.366 122.197C-157.366 64.9846 -109.731 18.6 -50.9658 18.6C7.7998 18.6 55.4342 64.9846 55.4342 122.197Z",
    stroke: "url(#paint12_linear_19491_32756)",
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.9986 122.197C46.9986 179.41 -0.635742 225.795 -59.4014 225.795C-118.167 225.795 -165.801 179.41 -165.801 122.197C-165.801 64.9846 -118.167 18.6 -59.4014 18.6C-0.635742 18.6 46.9986 64.9846 46.9986 122.197Z",
    stroke: "url(#paint13_linear_19491_32756)",
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.5631 122.197C38.5631 179.41 -9.07129 225.795 -67.8369 225.795C-126.603 225.795 -174.237 179.41 -174.237 122.197C-174.237 64.9846 -126.603 18.6 -67.8369 18.6C-9.07129 18.6 38.5631 64.9846 38.5631 122.197Z",
    stroke: "url(#paint14_linear_19491_32756)",
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.1266 122.197C30.1266 179.41 -17.5078 225.795 -76.2734 225.795C-135.039 225.795 -182.673 179.41 -182.673 122.197C-182.673 64.9846 -135.039 18.6 -76.2734 18.6C-17.5078 18.6 30.1266 64.9846 30.1266 122.197Z",
    stroke: "url(#paint15_linear_19491_32756)",
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.691 122.197C21.691 179.41 -25.9434 225.795 -84.709 225.795C-143.475 225.795 -191.109 179.41 -191.109 122.197C-191.109 64.9846 -143.475 18.6 -84.709 18.6C-25.9434 18.6 21.691 64.9846 21.691 122.197Z",
    stroke: "url(#paint16_linear_19491_32756)",
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.2555 122.197C13.2555 179.41 -34.3789 225.795 -93.1445 225.795C-151.91 225.795 -199.545 179.41 -199.545 122.197C-199.545 64.9846 -151.91 18.6 -93.1445 18.6C-34.3789 18.6 13.2555 64.9846 13.2555 122.197Z",
    stroke: "url(#paint17_linear_19491_32756)",
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.81992 122.197C4.81992 179.41 -42.8145 225.795 -101.58 225.795C-160.346 225.795 -207.98 179.41 -207.98 122.197C-207.98 64.9846 -160.346 18.6 -101.58 18.6C-42.8145 18.6 4.81992 64.9846 4.81992 122.197Z",
    stroke: "url(#paint18_linear_19491_32756)",
    strokeWidth: 0.2
  }))))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.08
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M320.545 29.2806V29.2803C320.545 26.8276 318.457 24.8854 315.953 24.8854C313.445 24.8854 311.352 26.8264 311.352 29.2803C311.352 31.7377 313.445 33.679 315.953 33.679C318.458 33.679 320.544 31.7312 320.545 29.2806ZM316.088 16.2723L316.085 16.2713H315.953C308.45 16.2713 302.296 22.0788 302.296 29.2795C302.296 35.3872 306.729 40.4897 312.641 41.9025V61.8364V61.8367C312.645 70.9871 303.564 78.6248 292.163 78.6248C286.623 78.6248 281.422 76.8275 277.52 73.5985C273.737 70.3929 271.683 66.2072 271.683 61.8372V42.0326C282.153 40.8084 290.422 33.2602 290.422 23.8777L290.421 12.888C293.905 11.789 296.474 8.68001 296.474 4.94923C296.474 0.291478 292.498 -3.44473 287.676 -3.44473C282.852 -3.44473 278.878 0.292351 278.878 4.94923C278.878 8.54045 281.256 11.55 284.537 12.7501V23.8777C284.537 30.8043 277.571 36.6389 268.741 36.6389C264.421 36.6389 260.407 35.2498 257.401 32.7266L257.401 32.7265L257.393 32.7206C254.506 30.3729 252.944 27.233 252.944 23.8777V12.888C256.428 11.7891 258.996 8.68002 258.996 4.94923C258.996 0.291478 255.021 -3.44473 250.198 -3.44473C245.375 -3.44473 241.4 0.292351 241.4 4.94923C241.4 8.54044 243.779 11.55 247.059 12.7501V23.8777C247.059 28.9478 249.39 33.6197 253.559 37.0111C256.924 39.8336 261.206 41.5216 265.798 42.0393V61.8341C265.798 67.8863 268.598 73.5791 273.651 77.8582L273.656 77.8623C278.663 82.011 285.238 84.2798 292.164 84.2798C306.607 84.2798 318.53 74.2976 318.53 61.8382V42.011C324.798 40.8613 329.6 35.6408 329.6 29.2855C329.601 22.1225 323.521 16.3408 316.088 16.2723ZM284.761 4.94844C284.761 3.46419 286.038 2.20788 287.675 2.20788C289.312 2.20788 290.589 3.46414 290.589 4.94844C290.589 6.43274 289.312 7.68899 287.675 7.68899C286.039 7.68899 284.761 6.42928 284.761 4.94844ZM247.283 4.94844C247.283 3.46419 248.56 2.20788 250.197 2.20788C251.834 2.20788 253.111 3.46414 253.111 4.94844C253.111 6.43274 251.834 7.68899 250.197 7.68899C248.561 7.68899 247.283 6.42928 247.283 4.94844ZM315.953 36.6385C311.641 36.6385 308.182 33.3118 308.182 29.2805C308.186 25.2521 311.641 21.9251 315.953 21.9251C320.261 21.9251 323.715 25.2517 323.715 29.2799C323.715 33.3077 320.264 36.6385 315.953 36.6385Z",
    fill: "#297166",
    stroke: "#297166",
    strokeWidth: 1.2
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_19491_32756",
    x1: 21,
    y1: 5.12698,
    x2: 215.06,
    y2: 128.401,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A7EAE5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CDFFFC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_19491_32756",
    x1: -4.7111e-7,
    y1: 1.85,
    x2: 162.715,
    y2: 209.199,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#57B079"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C7EDD7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_19491_32756",
    x1: 126.839,
    y1: 183.196,
    x2: -19.6802,
    y2: 119.388,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#008633"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#008633",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_19491_32756",
    x1: 118.404,
    y1: 183.196,
    x2: -28.1157,
    y2: 119.388,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#008633"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#008633",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_19491_32756",
    x1: 109.968,
    y1: 183.196,
    x2: -36.5513,
    y2: 119.388,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#008633"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#008633",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_19491_32756",
    x1: 101.533,
    y1: 183.196,
    x2: -44.9868,
    y2: 119.388,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#008633"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#008633",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_19491_32756",
    x1: 93.097,
    y1: 183.196,
    x2: -53.4224,
    y2: 119.388,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#008633"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#008633",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_19491_32756",
    x1: 84.6614,
    y1: 183.196,
    x2: -61.8579,
    y2: 119.388,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#008633"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#008633",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_19491_32756",
    x1: 76.2259,
    y1: 183.196,
    x2: -70.2935,
    y2: 119.388,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#008633"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#008633",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_19491_32756",
    x1: 67.7903,
    y1: 183.196,
    x2: -78.729,
    y2: 119.388,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#008633"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#008633",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_19491_32756",
    x1: 59.3538,
    y1: 183.196,
    x2: -87.1655,
    y2: 119.388,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#008633"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#008633",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_19491_32756",
    x1: 50.9182,
    y1: 183.196,
    x2: -95.6011,
    y2: 119.388,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#008633"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#008633",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear_19491_32756",
    x1: 42.4827,
    y1: 183.196,
    x2: -104.037,
    y2: 119.388,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#008633"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#008633",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint13_linear_19491_32756",
    x1: 34.0472,
    y1: 183.196,
    x2: -112.472,
    y2: 119.388,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#008633"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#008633",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint14_linear_19491_32756",
    x1: 25.6116,
    y1: 183.196,
    x2: -120.908,
    y2: 119.388,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#008633"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#008633",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint15_linear_19491_32756",
    x1: 17.1751,
    y1: 183.196,
    x2: -129.344,
    y2: 119.388,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#008633"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#008633",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint16_linear_19491_32756",
    x1: 8.73953,
    y1: 183.196,
    x2: -137.78,
    y2: 119.388,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#008633"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#008633",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint17_linear_19491_32756",
    x1: 0.303987,
    y1: 183.196,
    x2: -146.215,
    y2: 119.388,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#008633"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#008633",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint18_linear_19491_32756",
    x1: -8.13156,
    y1: 183.196,
    x2: -154.651,
    y2: 119.388,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#008633"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#008633",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_19491_32756"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 335,
    height: 74,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMedicalEquipmentBg);
export default __webpack_public_path__ + "static/media/Medical-equipment-bg.ff959f8ff6138a02db7cbf6b68207aed.svg";
export { ForwardRef as ReactComponent };